import { useEffect, useState } from "react";
import Button from "../../components/button";
import CardContainer from "../../components/card_container";
import Input from "../../components/input";
import InputImage from "../../components/input_image";
import InputSwitch from "../../components/input_switch";
import "./fabric.scss";
import UseFormFabric from "./hookForm";
import { useLocation } from "react-router-dom";
import useGet from "../../hooks/useGet";
import LoadingModal from "../../components/loading_modal";
import PreviewQR from "./previewQr";
const GenerateQrFabricsPage = () => {
  // const location = useLocation()
  // const [state, setState] = useState({})

  const {
    isLoadingPut,
    form,
    isOn,
    removePreview,
    handleSwitchBox,
    handleChange,
    handleImageChange,
    handleGenerateQr,
    handleSaveQr,
  } = UseFormFabric({
    type: "qr",
  });

  return (
    <>
      <CardContainer
        title={"Generate QR"}
        isBack={true}
        children={
          <div style={{ display: "flex", gap: "16px" }}>
            <div style={{ flex: 1 }}>
              <form
                className=""
                onSubmit={(e) => {
                  e.preventDefault();
                  const action = e.nativeEvent.submitter.name;

                  if (action === "print") {
                    // aksi Save
                    handleGenerateQr(e);
                  } else if (action === "save") {
                    // aksi Print
                    handleSaveQr(e);
                  }
                }}
              >
                <div className="form-fabric">
                  <div className="expanded-y">
                    <div>Paper (mm)</div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                      }}
                    >
                      <Input
                        style={{ width: "100%" }}
                        id="paperWidth"
                        onChange={handleChange}
                        label="Width"
                        placeholder="Input paper width"
                        required={true}
                        type="number"
                        min={0}
                        value={form.paperWidth}
                      />
                      <Input
                        style={{ width: "100%" }}
                        id="paperHeight"
                        onChange={handleChange}
                        label="Height"
                        placeholder="Input paper height"
                        required={true}
                        type="number"
                        min={0}
                        value={form.paperHeight}
                      />
                      <Input
                        style={{ width: "100%" }}
                        id="marginTop"
                        onChange={handleChange}
                        label="Margin Top"
                        placeholder="Input margin top"
                        required={true}
                        type="number"
                        min={0}
                        value={form.marginTop}
                      />
                      <Input
                        style={{ width: "100%" }}
                        id="marginBottom"
                        onChange={handleChange}
                        label="Margin Bottom"
                        placeholder="Input margin bottom"
                        required={true}
                        type="number"
                        min={0}
                        value={form.marginBottom}
                      />
                      <Input
                        style={{ width: "100%" }}
                        id="marginLeft"
                        onChange={handleChange}
                        label="Margin Left"
                        placeholder="Input margin left"
                        required={true}
                        type="number"
                        min={0}
                        value={form.marginLeft}
                      />
                      <Input
                        style={{ width: "100%" }}
                        id="marginRight"
                        onChange={handleChange}
                        label="Margin Right"
                        placeholder="Input margin right"
                        required={true}
                        type="number"
                        min={0}
                        value={form.marginRight}
                      />
                    </div>
                    <div style={{ marginTop: "16px" }}>
                      Box (mm)
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          flexWrap: "wrap",
                        }}
                      >
                        <Input
                          style={{ width: "100%" }}
                          id="boxWidth"
                          onChange={handleChange}
                          label="Width"
                          placeholder="Input box width"
                          required={true}
                          type="number"
                          min={0}
                          value={form.boxWidth}
                        />
                        <Input
                          style={{ width: "100%" }}
                          id="boxHeight"
                          onChange={handleChange}
                          label="Height"
                          placeholder="Input box height"
                          required={true}
                          type="number"
                          min={0}
                          value={form.boxHeight}
                        />
                        <Input
                          style={{ width: "100%" }}
                          id="gapX"
                          onChange={handleChange}
                          label="Gap-X"
                          placeholder="Input gap-x"
                          required={true}
                          type="number"
                          min={0}
                          value={form.gapX}
                        />
                        <Input
                          style={{ width: "100%" }}
                          id="gapY"
                          onChange={handleChange}
                          label="Gap-Y"
                          placeholder="Input gap-y"
                          required={true}
                          type="number"
                          min={0}
                          value={form.gapY}
                        />
                        <div
                          style={{
                            marginLeft: "12px",
                          }}
                        >
                          <InputSwitch
                            label={"Show Box"}
                            isOn={isOn}
                            onClick={() => handleSwitchBox("")}
                          />
                        </div>
                      </div>
                    </div>
                    <div style={{ marginTop: "16px" }}>
                      QR and Logo (mm)
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          flexWrap: "wrap",
                        }}
                      >
                        <Input
                          style={{ width: "100%" }}
                          id="qrSize"
                          onChange={handleChange}
                          label="QR Size"
                          placeholder="Input qr size"
                          required={true}
                          type="number"
                          min={0}
                          value={form.qrSize}
                        />
                        <Input
                          style={{ width: "100%" }}
                          id="fontSize"
                          onChange={handleChange}
                          label="Font Size"
                          placeholder="Input font size"
                          required={true}
                          type="number"
                          min={0}
                          value={form.fontSize}
                        />

                        <Input
                          style={{ width: "100%" }}
                          id="labelGapY"
                          onChange={handleChange}
                          label="Label Gap From QR(mm)"
                          placeholder="Input jarak label ke QR"
                          type="number"
                          min={0}
                          value={form.labelGapY}
                        />
                        {/* QR Margin Top */}
                        <Input
                          style={{ width: "100%" }}
                          id="qrMarginTop"
                          onChange={handleChange}
                          label="QR Margin Top (mm)"
                          placeholder="Jarak atas QR terhadap Box"
                          type="number"
                          min={0}
                          value={form.qrMarginTop}
                        />
                        {/* QR Margin Bottom */}
                        <Input
                          style={{ width: "100%" }}
                          id="qrMarginBottom"
                          onChange={handleChange}
                          label="QR Margin Bottom (mm)"
                          placeholder="Jarak bawah QR terhadap Box"
                          type="number"
                          min={0}
                          value={form.qrMarginBottom}
                        />
                        <Input
                          style={{ width: "100%" }}
                          id="qrMarginLeft"
                          onChange={handleChange}
                          label="QR Margin Left (mm)"
                          placeholder="Jarak kiri QR terhadap Box"
                          type="number"
                          min={0}
                          value={form.qrMarginLeft}
                        />
                        <Input
                          style={{ width: "100%" }}
                          id="logoUrl"
                          onChange={handleChange}
                          label="Logo URL"
                          placeholder="Input logo URL"
                          value={form.logoUrl}
                        />
                        <Input
                          style={{ width: "100%" }}
                          id="logoSize"
                          onChange={handleChange}
                          label="Logo Size (mm)"
                          placeholder="Input logo size"
                          type="number"
                          min={0}
                          value={form.logoSize}
                        />

                        {/* Logo Margin Top */}
                        <Input
                          style={{ width: "100%" }}
                          id="logoMarginTop"
                          onChange={handleChange}
                          label="Logo Margin Top (mm)"
                          placeholder="Jarak atas Logo terhadap Box"
                          type="number"
                          min={0}
                          value={form.logoMarginTop}
                        />
                        {/* Logo Margin Bottom */}
                        <Input
                          style={{ width: "100%" }}
                          id="logoMarginBottom"
                          onChange={handleChange}
                          label="Logo Margin Bottom (mm)"
                          placeholder="Jarak bawah Logo terhadap Box"
                          type="number"
                          min={0}
                          value={form.logoMarginBottom}
                        />
                        <Input
                          style={{ width: "100%" }}
                          id="gapQrLogo"
                          onChange={handleChange}
                          label="Gap QR-Logo (mm)"
                          placeholder="Input jarak QR ke logo"
                          type="number"
                          min={0}
                          value={form.gapQrLogo}
                        />
                      </div>
                    </div>
                  </div>
                  <hr style={{ width: "100%" }} />
                  <div className="footer-form">
                    <Button
                      type="button"
                      className="btn-outline-primary"
                      style={{ marginRight: "8px" }}
                      title="Cancel"
                      onClick={() => window.history.back()}
                    />
                    <Button
                      type="submit"
                      name="save"
                      className="btn-warning"
                      style={{ marginRight: "8px" }}
                      title="Save"
                    />
                    <Button
                      type="submit"
                      name="print"
                      className="btn-primary"
                      title="Print"
                    />
                  </div>
                </div>
              </form>
            </div>
            <div
              style={{
                flex: 1,
                border: "1px solid #ccc",
                padding: "16px",
                background: "#f9f9f9",
                maxHeight: "70vh", // tinggi maksimum tampilan viewport
                overflowY: "auto", // scroll vertikal jika banyak halaman
              }}
            >
              <PreviewQR form={form} />
            </div>
          </div>
        }
      />

      <LoadingModal isLoading={isLoadingPut} />
    </>
  );
};
export default GenerateQrFabricsPage;
